<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true"
    style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='带教老师月度奖金发放报表' label2="发放比较" url="/report/achievement/tec"></PageHead>
      <div class="m-portlet__body">
        <div class="m-form m-form--label-align-right">
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">比较月：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.grantmonth" type="month" placeholder="比较月" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">被比较月：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.comparemonth" type="month" placeholder="被比较月" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <el-button type="primary" icon="el-icon-search" @click="Search()">查询</el-button>
        </div>
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <div v-html="tableData">
          </div>
        </div>
        <!-- <div style="padding: .2rem 2.2rem;font-size: 16px;">
          {{condition.grantmonth}} 比 {{condition.comparemonth}} 多出 {{moretec}} 名带教老师
        </div>
        <div class="m-portlet__body" style="padding: 1rem 2.2rem;">
          <div v-html="tableData1">
          </div>
        </div>
        <div style="padding: .2rem 2.2rem;font-size: 16px;">
          {{condition.grantmonth}} 比 {{condition.comparemonth}} 少了 {{lesstec}} 名带教老师
        </div>
        <div class="m-portlet__body" style="padding: 1rem 2.2rem;">
          <div v-html="tableData2">
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AchievementTecCompare',
    data() {
      return {
        condition: {
          token: '',
          username: '',
          rolelevel: '',
          grantmonth: '',
          comparemonth: ''
        },
        comparemonth: '',
        moretec: 0,
        lesstec: 0,
        loading1: false,
        loading2: false,
        tableData: null,
        tableData1: null,
        tableData2: null,
      }
    },
    methods: {
      Search: function() {
        if (this.condition.grantmonth == null) {
          this.$message.error('比较月不能为空!')
          return
        }

        if (this.condition.comparemonth == null) {
          this.$message.error('被比较月不能为空!')
          return
        }

        var that = this
        this.$http.post(this.$utils.Url.zpgl + '/api/APIMoneyGrant/TecCompareList', this.condition)
          .then(res => {
            if (res.data.Code === 0) {
              that.tableData = res.data.Data
              // that.MoreTecCount()
              // that.LessTecCount()
            } else {
              that.tableData = null
              that.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
          })
          .catch(err => {
            that.tableData = null
            console.log(err)
            that.$message({
              message: '查询失败',
              type: 'error'
            })
          })

      },
      MoreTecCount: function() {
        var that = this
        this.$http.post(this.$utils.Url.zpgl + '/api/APIMoneyGrant/MoreTecCount', this.condition)
          .then(res => {
            if (res.data.Code === 0) {
              var results = res.data.Data.split('|')
              that.tableData1 = results[0]
              that.morestu = results[1]
            } else {
              that.tableData1 = null
              that.moretec = 0
              that.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
          })
          .catch(err => {
            that.tableData1 = null
            that.moretec = 0
            console.log(err)
            that.$message({
              message: '查询失败',
              type: 'error'
            })
          })
      },
      LessTecCount: function() {
        var that = this
        this.$http.post(this.$utils.Url.zpgl + '/api/APIMoneyGrant/LessTecCount', this.condition)
          .then(res => {
            if (res.data.Code === 0) {
              var results = res.data.Data.split('|')
              that.tableData2 = results[0]
              that.lesstec = results[1]
            } else {
              that.tableData2 = null
              that.lesstec = 0
              that.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
          })
          .catch(err => {
            that.tableData2 = null
            that.lesstec = 0
            console.log(err)
            that.$message({
              message: '查询失败',
              type: 'error'
            })
          })
      },
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.condition.username = sessionStorage.getItem('username')
      this.condition.rolelevel = sessionStorage.getItem('rolelevel')

      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      this.condition.grantmonth = year + '-' + month

      var cyear = 0
      var cmonth = 0
      if (date.getMonth() == 0) {
        cyear = year - 1
        cmonth = 12
      } else {
        cyear = year
        cmonth = date.getMonth()
        if (cmonth >= 1 && cmonth <= 9) {
          cmonth = '0' + cmonth
        }
      }

      this.condition.comparemonth = cyear + '-' + cmonth

      this.Search()
    }
  }
</script>

<style scoped="scoped">
::v-deep .el-input {
    width: 220px;
  }

::v-deep .tabTable tbody tr {
    height: 50px;
    line-height: 30px;
  }
</style>

<style scoped="scoped">
  @import '../../../assets/css/achievementinfo.css'
</style>

